module.exports = new __parcel__URL__("machine_upgrade_button.abec1006.png").toString();